import { createFileRoute } from '@tanstack/react-router'
import { CaseEdit } from 'pages/cases/CaseEdit'
import { z } from 'zod'

const parseParams = z.object({
  siteID: z.string(),
  caseID: z.string(),
})

export const Route = createFileRoute('/cases/$siteID/edit/$caseID')({
  component: CaseEdit,
  params: {
    parse: parseParams.parse,
  },
  staticData: {
    title: 'Edit Case',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
